<template>
  <v-snackbar
    class="snackbar"
    v-model="show"
    :timeOut="timeOut"
    :top="top"
    :color="color"
  >
    {{ text }}
  <v-btn
    color="white"
    flat
    @click="close"
  >
    <v-icon>close</v-icon> 
  </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'PSnackBar',
  props: {
    text: {
      type: String,
      required: true
    },
    show: {
      type: Boolean,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    timeOut: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      top: true
    };
  },
  methods: {
    close () {
      this.$emit('update:show', false);
    }
  },
  watch: {
    show (val) {
      if (val === true && this.timeOut) {
        setTimeout(() => {
          this.$emit('update:show', false);
        }, this.timeOut);
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// Snackbar.vue?3de0537f